@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

class IPLockingConfigDto (
    val enforce: Boolean?,
    val allowedIpAddresses: Array<String>?,
    val allowedClientIds: Array<String>?,
    )